// extracted by mini-css-extract-plugin
export default {"editor":"BuwTpzsE7Jc5mRRPyUpH","footer":"tkHoxE90348xdrIl3CvR"};